import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Navigation from "@/components/landing/Navigation";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import Solution from "@/components/landing/Solution";
import Mast from "@/components/landing/Mast";
import JunctionBox from "@/components/landing/JunctionBox";
import KonfiguratorSection from "@/components/landing/KonfiguratorSection";
import Advantages from "@/components/landing/Advantages";
import Applications from "@/components/landing/Applications";
import TechnicalDetails from "@/components/landing/TechnicalDetails";
import Documents from "@/components/landing/Documents";
import Footer from "@/components/landing/Footer";

import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import Konfigurator from "@/pages/Konfigurator";

function Landing() {
  return (
    <div className="app-shell" data-testid="landing-page">
      <Navigation />
      <main>
        <Hero />
        <Problem />
        <Solution />
        <Mast />
        <JunctionBox />
        <KonfiguratorSection />
        <Advantages />
        <Applications />
        <TechnicalDetails />
        <Documents />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/konfigurator" element={<Konfigurator />} />
      </Routes>
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
